module.exports = __webpack_public_path__ + "img/Stelle_Infrastruktur.80e5af45.svg";